"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createButtonSubmissionEventWithEventNameAndItem = exports.createButtonSubmissionEventWithEventName = void 0;

var _constants = _interopRequireDefault(require("../constants"));

var _Utils = _interopRequireDefault(require("../Utils"));

var createButtonSubmissionEventWithEventName = function createButtonSubmissionEventWithEventName(eventName) {
  var buttonSubmissionEvent = {};

  _Utils["default"].setEventCategory(buttonSubmissionEvent, _constants["default"].PrimaryCategories.ButtonSubmission);

  _Utils["default"].setEventEventInfo(buttonSubmissionEvent, eventName);

  return buttonSubmissionEvent;
};

exports.createButtonSubmissionEventWithEventName = createButtonSubmissionEventWithEventName;

var createButtonSubmissionEventWithEventNameAndItem = function createButtonSubmissionEventWithEventNameAndItem(eventName, item) {
  var buttonSubmissionEvent = createButtonSubmissionEventWithEventName(eventName);

  _Utils["default"].setEventProperty(buttonSubmissionEvent, _constants["default"].PropertyPaths.Item, item);

  return buttonSubmissionEvent;
};

exports.createButtonSubmissionEventWithEventNameAndItem = createButtonSubmissionEventWithEventNameAndItem;
//# sourceMappingURL=buttonSubmission.js.map